<div class="fund-wallet-dialog">
  <label>
    Enter Amount (N)
  </label>

  <div>
    <input type="number" placeholder="Enter Amount" required="true" [(ngModel)]="amount" #amountInput="ngModel">
    @if (amountInput.invalid && (amountInput.dirty || amountInput.touched)) {
      <small>
        @if (amountInput.errors?.['required']) {
          <p>
            amount is required
          </p>
        }
      </small>
    }
  </div>


  <button [disabled]="amountInput.invalid || isLoading" (click)="onFundWallet()" class="btn btn-fund">
    @if (isLoading) {
      <i class="fa fa-spin fa-spinner"></i>
    }
    FUND WALLET
  </button>
</div>
